export default {
  'setOwnerCutPerMillion(uint256)': 'Set fees to `@formatPct($1, 1000000)`%',
  'transferMarketplaceOwnership(address)':
    'Transfer ownership of the marketplace to `$1`',
  'transferOwnership(address)': 'Transfer ownership of the contract to `$1`',
  'pause()': 'Pause contract',
  'unpause()': 'Unpause Contract`',
  'upgrade(address,bytes)': 'Upgrade the contract to `$1`',
  'upgradeTo(address)': 'Upgrade the contract to `$1`',
  'upgradeToAndCall(address,bytes)': 'Upgrade the contract to `$1`',
  'setLandBalanceToken(address)': 'Set LAND balance token `$1`',
  'setEstateLandBalanceToken(address)': 'Set LAND balance token `$1`'
}
